export default __webpack_public_path__ + "static/media/Correct Answer.9a17bef8.svg";